export default function WhyProgramsWork() {
  const steps = [
    {
      icon: 'ri-search-eye-line',
      step: '01',
      title: 'Диагностика',
      desc: 'Изучение бизнеса, интервью, аудит переговоров и KPI. Определение точек роста и измеримых целей.'
    },
    {
      icon: 'ri-file-settings-line',
      step: '02',
      title: 'Подготовка',
      desc: 'Разработка индивидуальной программы, адаптация кейсов под специфику компании, согласование с руководителем.'
    },
    {
      icon: 'ri-presentation-line',
      step: '03',
      title: 'Практический тренинг',
      desc: '80% практики: ролевые игры, разбор реальных звонков и переписок, отработка навыков на кейсах компании.'
    },
    {
      icon: 'ri-rocket-line',
      step: '04',
      title: 'Внедрение',
      desc: 'Создание регламентов, скриптов, чек-листов. План внедрения с контрольными точками и ответственными.'
    },
    {
      icon: 'ri-chat-smile-3-line',
      step: '05',
      title: 'Сопровождение',
      desc: 'Регулярные встречи, аудит, домашние задания с обратной связью, Telegram-чат. От 1 до 6 месяцев.'
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      step: '06',
      title: 'Измерение результата',
      desc: 'Фиксация исходных KPI, промежуточные замеры, итоговый отчёт с динамикой показателей.'
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему мои программы работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Это не магия и не мотивационные речи. Это системный подход, который даёт предсказуемый результат.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map((step, i) => (
            <div key={i} className="relative bg-white rounded-xl p-6 md:p-7 hover:shadow-md transition-all duration-300 group cursor-default">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                  {step.step}
                </div>
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-teal-600 transition-colors duration-300">
                  <i className={`${step.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
                </div>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>

              {/* Arrow connector */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 z-10">
                  <div className="w-6 h-6 bg-teal-100 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-teal-600 text-sm"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom quote */}
        <div className="mt-12 max-w-3xl mx-auto bg-teal-50 border border-teal-200 rounded-xl p-6 md:p-8 text-center">
          <p className="text-lg md:text-xl font-bold text-teal-800 leading-relaxed">
            Главное отличие — я не провожу «тренинг ради тренинга». Каждая программа направлена на конкретные бизнес-результаты, которые можно измерить в деньгах.
          </p>
        </div>
      </div>
    </section>
  );
}